<template>
  <div>
    <template>
      <div style="height:100%;background:#fff" ref="container">
        <div class="col-md-12" style="padding: 10px;" v-if="defaultView == 'dayGridMonth' ">
          <div class="col-md-4 pL0" style="text-align: left;">
            <button
              :disabled="isCurrentMonth"
              class="todayButton"
              @click="onTodayButtonClick()"
            >Today</button>
            <span class="arrow_icon" @click="OnPreviousMonthClick()">
              <img id="prev" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_previous.svg`" />
            </span>
            <span class="arrow_icon" @click="OnNextMonthClick()">
              <img id="next" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_next.svg`" />
            </span>
          </div>
          <div class="col-md-4 text-center">
            <div class="dropdown show" style="display: inline-block !important;">
              <ob-popover
                :visibleArrow="false"
                class="popover-class"
                trigger="click"
                :options="{placement: 'bottom'}"
                ref="popover"
              >
                <div class="popper">
                  <template v-for="item in monthNames">
                    <span style="cursor:pointer"
                      v-if="item != MonthSelected"
                      @click="onMonthSelected(item)"
                      class="snooze-options"
                    >{{item}}</span>
                  </template>
                </div>
                <span slot="reference">
                  <span
                    @click="isMonthPoperOpend = !isMonthPoperOpend"
                    style="font-size: 20px;color:#1e1e1f;font-weight: 600;display: inline-block;text-transform: uppercase; "
                  >{{MonthSelected}}</span>
                  <i
                    style="color: black;font-size: 20px;"
                    class="fa fa-caret-down"
                    @click="isMonthPoperOpend = true"
                    v-if="!isMonthPoperOpend"
                    aria-hidden="true"
                  ></i>
                  <i
                    style="color: black;font-size: 20px;"
                    class="fa fa-caret-up"
                    @click="isMonthPoperOpend = false"
                    v-else
                    aria-hidden="true"
                  ></i>
                </span>
              </ob-popover>
            </div>
          </div>
          <div class="col-md-4 pR0" style="text-align: right;">
            <span class="totalHoursLable">
              Total Hours Worked :
              <span v-html="TotalHoursWorkrdInFormat"></span>
            </span>
          </div>
        </div>
        <div class="col-md-12" style="z-index: 0" v-show="!EditTimesheetToApprove">
          <FullCalendar
            timeZone = "UTC"
            @renderEvent="renderEvent"
            @eventClick="eventClick"
            @dayRender="dayRender"
            :fixedWeekCount="false"
            :aspectRatio="aspectRatio"
            @eventRender="eventRender"
            @eventSelected="eventSelected"
            @datesRender="datesRender"
            @eventPositioned="eventPositioned"
            class="timesheet-calendar"
            ref="fullCalendar"
            :titleFormat="titleFormat"
            :header="false"
            :defaultView="defaultView"
            :plugins="calendarPlugins"
            :weekends="weekends"
            :events="events"
          />
        </div>
        <div v-bind:style="showPopover ? 'z-index: 1060;' : 'z-index: -1;'"
          ref="timeSheetPopoverWrapper"
          :class="eventObj.length == 1 && eventObj[0].CalendarType == 'Holiday' ? 'popover-custom-width-holiday' : (eventObj.length == 1 && (eventObj[0].Status == 'Approved' || eventObj[0].ExpenseStatus == 'Approved') && eventObj[0].CalendarType == 'TimeSheet') ? 'popover-custom-width-timesheet-Approved': eventObj.length == 1 && (eventObj[0].Status == 'Approved' || eventObj[0].ExpenseStatus == 'Approved') ? 'popover-custom-width-Approved':'popover-custom-width-Pending'"
          class="timesheet-popover-wrapper"
          v-if="showTimeSheetsPopover"
          v-click-outside-for-dynamic-elements="closeTimeSheetsPopover"
        >
          <TimeSheetPopover :EventInfo="eventObj" :CurrentView="defaultView" :IsEditTimesheetFlag="IsEditTimesheet"  :IsReportTypeSelectedCombined.sync = "IsReportTypeSelectedCombined" :selectedtimesheet ="selectedtimesheet"></TimeSheetPopover>
        </div>
        <div class="Expense_popOver"
          ref="expensePopoverWrapper"
          v-if="showExpensePopover"
          v-click-outside-for-dynamic-elements="closeExpensePopover" 
        >
          <div class="row"  v-if="(isModalvisible && IsDCAAComplianceToggleOn)" style="border-bottom: 1.5px solid #c9ccd0;margin-bottom:20px;padding-bottom:20px">
            <div class="col-md-12">
              <div class="col-md-2 pL0">
                <img style="width:80px;height:50px;padding-right:10px;padding-top:5px" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/alert.svg`"/>
              </div>
              <div class="col-md-10">
                 <p style="font-size: 15px;color:#EF4457;padding-bottom:8px;font-weight: 550;">Missing Timesheet</p>
                 <p style="font-size: 12px;color:black;padding-bottom:8px;font-weight: 550;" v-if="submissionPreferenceType == 'MustBeEnteredOnSameDay'">{{Employeename}} haven't submitted today's  ({{this.missingTimesheetDate}}) timesheet.</p>
                 <p style="font-size: 12px;color:black;padding-bottom:8px;font-weight: 550;" v-else-if="submissionPreferenceType == 'CanBeEnteredOnTheNextDay'">{{Employeename}} haven't submitted Yesterday  ({{this.missingTimesheetDate}}) timesheet.</p>
                 <p style="font-size: 12px;color:black;padding-bottom:8px;font-weight: 550;" v-else-if="submissionPreferenceType == 'CanBeEnteredInWeeksTime'">{{Employeename}} haven't submitted this week timesheet.</p>
                 <p style="font-size: 11px;">Note: Your organization enabled DCAA compliance</p>
              </div>
            </div>
          </div>
          <div class="row" style="color:black">
            <p style="font-size: 12px;color:black;padding-left:15px;padding-bottom:8px;font-weight: 550;">Total Timesheets Hours</p>
            <div class="col-md-4" style="font-size: 11px">
                  <span class="circle1"></span><span>Pending: </span>
                  <span class="data_field">{{PendingHr}}</span>
                </div>
              <div class="col-md-4" style="font-size: 11px;">
                <span class="circle2"></span><span> Approved: </span>
                 <span class="data_field">{{ApprovedHrs}}</span>
              </div>
                <div class="col-md-4" style="font-size: 11px">
                  <span class="circle3"></span><span>Rejected: </span>
                  <span class="data_field">{{RejectedHrs}}</span>
                </div>
          </div>
          <div class="row" style="color:black">
            <p style="font-size: 12px;color:black;padding-left:15px;padding-top:20px;padding-bottom:8px;font-weight: 550;">Total Expenses</p>
            <div class="col-md-4" style="font-size: 11px">
                  <span class="circle1"></span><span>Pending: </span>
                  <span class="data_field">${{PendingExpense}}</span>
              </div>
               <div class="col-md-4" style="font-size: 11px">
                  <span class="circle2"></span><span>Approved: </span>
                  <span class="data_field">${{ApprovedExpense}}</span>
                </div>
              <div class="col-md-4" style="font-size: 11px">
                  <span class="circle3"></span><span>Rejected: </span>
                  <span class="data_field">${{RejectedExpense}}</span>
              </div>
          </div>
          <div style="text-align:center;margin-top:20px">
            <ob-button type="primary"  v-if=" IsDCAAComplianceToggleOn"  @click="ViewActivityLog()"><img  style="padding-right:10px;width:26px;height:13px" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_listview.svg`"/><span> Activity Log</span></ob-button>
          </div>
        <!-- <ExpensePopover></ExpensePopover> -->
        </div>
        <div class="hr_popOver"
          ref="hrPopoverWrapper"
          v-if="showHrPopover"
          v-click-outside-for-dynamic-elements="closeHrPopover"
        >
          <div class="row" style="color:black">
            <p style="font-size: 12px;color:black;padding-left:15px;padding-bottom:8px;font-weight: 550;">Total Timesheets Hours</p>
            <div class="col-md-4" style="font-size: 11px">
                  <span class="circle1"></span><span>Pending</span><br>
                  <span  class="data_field">{{yrPendingHrs}} </span>
                </div>
              <div class="col-md-4" style="font-size: 11px;">
                <span class="circle2"></span><span> Approved</span><br>
                 <span  class="data_field">{{yrApprovedHrs}}</span>
              </div>
                <div class="col-md-4" style="font-size: 11px">
                  <span class="circle3"></span><span>Rejected</span><br>
                  <span class="data_field">{{yrRejectedHrs}}</span>
                </div>
          </div>
        </div>
        <div class="Expense_popOver1"
          ref="expPopoverWrapper"
          v-if="showExpPopover"
          v-click-outside-for-dynamic-elements="closeExpPopover"
        >
          <div class="row" style="color:black">
            <p style="font-size: 12px;color:black;padding-left:15px;padding-bottom:8px;font-weight: 550;">Total Expenses</p>
               <div class="col-md-4" style="font-size: 11px">
                  <span class="circle1"></span><span>Pending</span><br>
                  <span class="data_field">${{yrPendingExpense}}</span>
                </div>
              <div class="col-md-4" style="font-size: 11px;">
                <span class="circle2"></span><span>Approved</span><br>
                 <span class="data_field">${{yrApprovedExpense}}</span>
              </div>
                <div class="col-md-4" style="font-size: 11px">
                  <span class="circle3"></span><span>Rejected</span><br>
                  <span class="data_field">${{yrRejectedExpense}}</span>
              </div>

          </div>
        </div>
      </div>
    </template>
    <template v-if="EditTimesheetToApprove">
      <employer-editTimesheet
        :selectedReport.sync="selectedEventInfo"
        :timesheetEmployeeId="TimesheetEmployeeId"
        :TimesheetId="TimesheetId"
        :TimesheetOrExpense="TimesheetOrExpense"
      ></employer-editTimesheet>
    </template>
    <!-- <evaluation-report
      :iframeURL="iframeURL"
      :selectedReport.sync="selectedEventInfo"
      :openModal.sync="openEvaluationReport"
    ></evaluation-report>-->
    <div>        
        <ob-modal2 :show.sync="showRequestPopUp" :width="600">
          <div slot="modal-title">Specify a reason to re-submit</div>
          <div slot="modal-body" style="text-align:center">
              <ob-textarea :maxLength="1200" style="width: 565px;height: 120px;resize:none;" v-model.trim="reasonForReSubmit"></ob-textarea>
          </div>
          <template slot="modal-footer">
            <div slot="modal-soc--footer" style="text-align:right;">
              <ob-button type="secondary" style="width: 80px;height: 35px;" @click="closeResubmitRequestPopUp()">Cancel</ob-button>
              <ob-button type="primary" style="width: 80px;height: 35px;" :disabled="reasonForReSubmit == null || reasonForReSubmit == ''" @click="RequestToReSubmit()">Submit</ob-button>
            </div>
          </template>
        </ob-modal2>
        <ob-modal2 :show.sync="openRemindPopUp" :type="1" :width="800" :height="800" :backdrop="false">
          <div class="modal-soc--header" style="padding:20px 20px 10px 20px;text-align:left;">
            <h2 class="modal-title">Remind Approver</h2>
            <p style="font-size:13px;font-weight:600;padding-top:5px">This email will be sent to {{ApproverName}} as a Reminder of <span v-if="TimesheetExpenseType == 'Expense'">Expense</span><span v-else>Timesheet</span> approval</p>
          </div>
          <div class="modal-soc--body" style="padding:0px 15px 30px 15px;">
            <div style="background-color: #f3f3f3;border-radius:10px;">
              <button v-if="copyShow == false" class="pull-right" style="border:1px solid #fff;background: #7cb2f2;color: #fff;text-align: center;border-radius:10px;padding:1%"  @click="copyEmail"><span><img style="margin-right: 2px; width:28px !important; height:29px !important; display:inline;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/ic_copy_white.svg`"  alt="icon"/>&nbsp;Copy Email</span></button>
              <button v-else class="pull-right" style="border:1px solid #fff;background: #7cb2f2;color: #fff;text-align: center;border-radius:10px;padding:1%"><span v-tooltip.top="'Copied'"><img style="margin-right: 2px; width:28px !important; height:29px !important; display:inline;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/ic_copy_white.svg`" />&nbsp;Copy Email</span></button>
              <h4 style="text-align:center;font-weight:bold;color:black;padding-top:5%">Important! Review for {{TimesheetEmployeeName}}’s <span v-if="TimesheetExpenseType == 'Expense'">Expense</span><span v-else>Timesheet</span>(s) is pending!</h4>
              <div ref="copyData">
                <p style="text-align:left;padding:3%;font-size:13px;font-weight:600">Hello {{ApproverName}},</p>
                <p style="padding-left:3%;padding-right:3%;line-height:20px;font-size:13px;font-weight:600">{{TimesheetEmployeeName}}  <span v-if="TimesheetExpenseType == 'Expense'">Expense</span><span v-else>Timesheet</span>(s) review for {{ProjectTitle}} dated {{FromDate}} till {{ToDate}} is pending.<br>
                In case of any issues or queries regarding the <span v-if="TimesheetExpenseType == 'Expense'">Expense</span><span v-else>Timesheet</span>(s) review, please feel free to contact us.</p>
                <p style="padding:3%;line-height:20px;font-size:13px;font-weight:600">Link to the <span v-if="TimesheetExpenseType == 'Expense'">Expense</span><span v-else>Timesheet</span>(s):
                <a :href="`${APPLICATIONBASEURL}/app/approve-authority?timesheetId=${TimesheetId}&type=${TimesheetExpenseType}`" target="_blank" style="text-decoration: none;">{{this.APPLICATIONBASEURL}}/app/approve-authority?timesheetId={{TimesheetId}}&type={{TimesheetExpenseType}}`</a><br>
                <!-- One Time Password: {{OTPForVerify}} -->
                </p>
                <p style="padding-left:3%;padding-bottom:3%;line-height:20px;font-size:13px;font-weight:600">
                  Best Regards<br>
                  {{loggedInUserObj.name}}<br>
                  Supervisor
                </p>
              </div>
            </div>
          </div>
          <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
            <ob-button type="secondary" @click="closeRemindApproverPopUp()">Cancel</ob-button>
            <ob-button @click="OnRemind()">Remind</ob-button>
          </div>
        </ob-modal2>
        <ob-modal2 :show.sync="showRequestForEditPopUp" :width="600">
          <div slot="modal-title">Specify a reason for edit request</div>
          <div slot="modal-body" style="text-align:center">
              <ob-textarea :maxLength="1200" style="width: 565px;height: 120px;resize:none;" v-model.trim="reasonForEdit" placeholder="Enter reason for edit request"></ob-textarea>
          </div>
          <template slot="modal-footer">
            <div slot="modal-soc--footer" style="text-align:center;">
              <ob-button type="secondary" style="width: 80px;height: 35px;" @click="closeEditRequestPopUp()">Cancel</ob-button>
              <ob-button type="primary" style="width: 100px;height: 35px;" :disabled="reasonForEdit == null || reasonForEdit == ''" @click="RequestToEdit()">Send Request</ob-button>
            </div>
          </template>
        </ob-modal2>
        <ob-modal2 :show.sync="showApproveOrRejectPopUp" :width="600">
          <div slot="modal-title">
              <span v-if="approveRequest">Approve Edit Request by {{RequestedEmployeeName}}</span>
              <span v-else-if="rejectRequest">Reject Edit Request by {{RequestedEmployeeName}}</span>
          </div>
          <div slot="modal-body">
              <ob-textarea :maxLength="1200" style="width: 565px;height: 120px;resize:none;text-align:left" v-model.trim="reasonForApproveOrReject" placeholder="Please mention any comments"></ob-textarea>
              <p style="font-size: 12px;text-align:left" v-if="approveRequest">Note: Approval information will be saved in activity log</p>
              <p style="font-size: 12px;text-align:left" v-else-if="rejectRequest">Note: Reject information will be saved in activity log</p>
          </div>
          <template slot="modal-footer">
            <div slot="modal-soc--footer" style="text-align:center;">
              <ob-button type="secondary" style="width: 80px;height: 35px;" @click="closeRequestApproveOrRejectPopUp()">Cancel</ob-button>
              <ob-button v-if="approveRequest" type="primary" style="width: 120px;height: 35px;" :disabled="reasonForApproveOrReject == null || reasonForApproveOrReject == ''" @click="RequestApproveOrReject('approve')">Approve Request</ob-button>
              <ob-button v-else-if="rejectRequest" type="primary" style="width: 120px;height: 35px;" :disabled="reasonForApproveOrReject == null || reasonForApproveOrReject == ''" @click="RequestApproveOrReject('reject')">Reject Request</ob-button>
            </div>
          </template>
        </ob-modal2>
    </div>
    <delete-timesheet :openDeletetimesheetPopup.sync="openDeleteTimesheetPopup" @Delete="DeleteTimesheetM" :type="DeleteType"></delete-timesheet>
     <ob-modal2 :show.sync="openPopUpSelectReportType" :backdrop="false" width="700px">
        <template slot="modal-title" >
          View Report
        </template>
        <template slot="modal-body" >
<div class="row form-group">
        <div class="col-md-12">        
          <label style="font-size:13px;">How would you like to generate report ?</label>
          <!-- <label style="font-size:12px;font-weight: 600; color: #4688D5;">
            Note:The task details include the task title, description, created date, duration, comments, and employer or supervisor          </label> -->

          <div class="form-group" style="display: flex;flex-direction: column;">
              <div class="col pL0">
                  <div class="radio-inline" style="padding-left:0px;">
                      <ob-radio name="IsIncludeTaskDescription" v-model="isCombinedReport" :val="true"><div><div style="font-weight: bold;">Combined  Report </div><p>Select this option to generate a combined report that totals all weekly time logs into a single monthly summary.</p></div></ob-radio>
                  </div>
              </div>
              <div class="col  pL0">
                  <div class="radio-inline" style="padding-left:0px;">
                      <ob-radio name="IsIncludeTaskDescription" v-model="isCombinedReport" :val="false"><div><div style="font-weight: bold;">Detailed  Report</div><p>Select this option to generate a detailed report showing individual data separately, along with task descriptions and details.</p></div></ob-radio>
                  </div>
              </div>
          </div>

        </div>
      </div>
        </template>
        <template slot="modal-footer">
          <ob-button   type="secondary" @click="cancelSelectReportTypePopUp()">Cancel</ob-button>
          <ob-button   @click="ViewReportForSelectedType()">View</ob-button>
        </template>

      </ob-modal2>
  </div>
</template>
<script>
import moment from "moment";
import { createPopper } from '@popperjs/core';
import utils from "@/components/Core/utils.js";

import EvaluationReport from "../ApprovalReport.vue";
// import EvaluationReport from "../EvaluationReport.vue";

import EmployerEditTimesheet from "./ApprovalFlow/EmployerEditTimesheet";
import TimeSheetPopover from "./TimeSheetPopover.vue";
//import ExpensePopover from "./ExpensePopover.vue"
import jquery from "jquery";
import bootstrap from "bootstrap";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import DeleteTimesheet from './DeleteTimesheetPopup.vue'
import customViewPlugin from "./CustomViews/custom-view-yearly.js";
import c from 'Vue/Core/constants.js'

export default {
  props: {
    weekends: {
      type: Boolean,
      default: true
    },
    calendarPlugins: {
      type: Array,
      default() {
        return [dayGridPlugin, customViewPlugin];
      }
    },
    defaultView: {
      type: String,
      default: "dayGridMonth"
    },
  },
  components: {
    FullCalendar,
    TimeSheetPopover,
    //ExpensePopover,
    // "approval-report": ApprovalReport,
    "evaluation-report": EvaluationReport,
    "employer-editTimesheet": EmployerEditTimesheet,
    "delete-timesheet" : DeleteTimesheet,
  },
  data() {
    return {
      DtimesheetId:'',
      DeleteTimesheet:{},
      DeleteType:'',
      openDeleteTimesheetPopup:false,
      EventIdList:[],
      MonthlyHoursExpense:[],
      yrApprovedExpense:0,
      yrPendingExpense:0,
      yrApprovedHrs:0,
      yrPendingHrs:0,
      Approvedhr :0,
      Approvedmin :0,
      Pendinghr  :0,
      Pendingmin :0,
      yearlyCalList:[],
      showExpPopover:false,
      showHrPopover:false,
      showExpensePopover : false,
      showPopover : false,
      EditTimesheetToApprove: false,
      TimesheetEmployeeId: "",
      TimesheetId: "",
      isMonthPoperOpend: false,
      MonthSelected: moment().format("MMMM"),
      IsPagefullLoad: false,
      showTimeSheetsPopover: false,
      selectedEventInfo: {},
      eventObj: {},
      ApprovedHrs : 0,
      PendingHr :0,
      ApprovedExpense :"",
      PendingExpense :"",
      Employeename:"",
      eventsArray: [
        {
          id: 1,
          title: "",
          start: "2019-05-13",
          end: "2019-05-20",
          EventObj: {
            CalendarType: "TimeSheet",
            Status: "Approved"
          },
          type: "TimeSheet",
          status: "Approved"
        }
      ],
      EventInfo: "",
      aspectRatio: 2.6,
      header: {
        // left: "today",
        // center: "prev,title,next",
        // right: "myCustomButton"
      },
      titleFormat: {
        month: "long"
      },
      TotalHoursWorkrd: "0h",

      // Approval Report
      CanEvaluate: true,
      isEdit: false,
      openApprovalreport: false,
      openEvaluationReport: false,
      iframeURL: "",
      IsEditTimesheet: false,
      reasonForReSubmit: "",
      showRequestPopUp:false,
      openRemindPopUp:false,
      copyShow:false,
      ProjectTitle:'',
      FromDate:'',
      ToDate:'',
      ApproverName:'',
      IsDCAAComplianceToggleOn:false,
      OTPForVerify:'',
      TimesheetEmployeeName:'',
      TimesheetOrExpense:'',
      showRequestForEditPopUp:false,
      reasonForEdit:'',
      showApproveOrRejectPopUp:false,
      reasonForApproveOrReject:'',
      approveRequest:false,
      rejectRequest:false,
      RejectedHrs :0,
      RejectedExpense :"",
      yrRejectedHrs:0,
      yrRejectedExpense:0,
      requestForResubmitType:'',
      requestToEditType:'',
      approveOrRejectRequestType:'',
      RequestedEmployeeName:'',
      TimesheetExpenseType:'',
      missingTimesheetDate:moment("01/01/1970").format("MM/DD/YYYY"),
      submissionPreferenceType:'',
      missingTimesheetDate1:moment("01/01/1970").format("MM/DD/YYYY"),
      isModalvisible:false,
      LegendEmployeeId:'',
      openPopUpSelectReportType: false,
      IsReportTypeSelectedCombined: false,
      selectedtimesheet :{
        id :"",
        clickedType : ""
      },
      isCombinedReport : "",
      //enddate: moment().format('MM/DD/YYYY'),
    };
  },
  watch: {
    MonthSelected(val) {
      let x = `${this.$parent.$parent._data.Year}-${this.selectedMonthNumber}-01`;
      let date = moment(x).format("YYYY-MM-DD");
      this.updateURL(date);
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(date);
    },
    openApprovalreport(val) {
      this.$emit("hideLegend", val);
    },
    openEvaluationReport(val) {
      this.$emit("hideLegend", val);
    },
    changed(val) {
      alert(val);
    },
    defaultView(v) {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.changeView(v);

      if (v == "customViewYearly") {
        calendarApi.refetchEvents();
      }
      else if (v == "dayGridMonth") {
        calendarApi.changeView(v);
      }
    },
    openRemindPopUp(val){
      if(val == false){
        this.copyShow = false
      }
    },
        IsReportTypeSelectedCombined(val){
        this.openPopUpSelectReportType = val
    }
  },
  mounted() {
    if (this.defaultView == "dayGridMonth") {
      var sDate = moment(
        decodeURIComponent(this.getUrlVars()["calenderDate"])
      ).format("MM/DD/YYYY");
      var calenderDate = sDate && sDate != "Invalid date" ? sDate : null;
      if (
        calenderDate != null &&
        calenderDate != "" &&
        calenderDate != undefined
      ) {
         let date = moment(calenderDate).format("YYYY-MM-DD");
        this.updateURL(date);
        this.MonthSelected = moment(date).format("MMMM");
        let calendarApi = this.$refs.fullCalendar.getApi();
        calendarApi.gotoDate(date);
      }
    }
  },
  computed: {
    TotalHoursWorkrdInFormat() {
      var Hours = this.TotalHoursWorkrd;
      let total = new Array();
      if (Hours != null && Hours != undefined && Hours != "") {
        total = Hours.split(" ");
      }
      var h = 0;
      var m = 0;
      let hrs = 0;
      let min = 0;
      if (total.length == 2) {
        h = total[0];
        m = total[1];
        if (h) {
          hrs = parseInt(h.replace("h", "")) || 0;
        }
        if (m) {
          min = parseInt(m.replace("m", "")) || 0;
        }
      } else if (total.length == 1) {
        if (total[0].includes("h")) {
          h = total[0];
        } else if (total[0].includes("m")) {
          m = total[0];
        }
        if (h) {
          hrs = parseInt(h.replace("h", "")) || 0;
        }
        if (m) {
          min = parseInt(m.replace("m", "")) || 0;
        }
      }
      let monthlyHours = 0;
      if (hrs != 0 && min != 0) {
        monthlyHours = `<span style="font-weight: 600;display: inline-block;font-size: 19px;color: #232323;">${hrs +
          '</span><p style="font-weight: 600;display: inline-block;font-size: 15px;">h</p> <span style="font-weight: 600;display: inline-block;font-size: 19px;color: #232323;">'}${min +
          '</span><p style="font-weight: 600;display: inline-block;font-size: 15px;">m</p>'}`;
      } else if (hrs != 0 && min == 0) {
        monthlyHours = `<span style="font-weight: 600;display: inline-block;font-size: 19px;color: #232323;">${hrs +
          '</span><p style="font-weight: 600;display: inline-block;font-size: 15px;">h</p>'}`;
      } else if (hrs == 0 && min != 0) {
        monthlyHours = `<span style="font-weight: 600;display: inline-block;font-size: 19px;color: #232323;">${min +
          '</span><p style="font-weight: 600;display: inline-block;font-size: 15px;">m</p>'}`;
      } else {
        monthlyHours = `<span style="font-weight: 600;display: inline-block;font-size: 19px;color: #232323;">0</span><p style="font-weight: 600;display: inline-block;font-size: 15px;">h</p>`;
      }

      return monthlyHours;
    },
    isCurrentMonth() {
      let x = `${this.$parent.$parent._data.Year}-${this.selectedMonthNumber}-01`;
      let selectedDate = moment(x).format("YYYY-MM");
      let curentDate = moment().format("YYYY-MM");
      if (selectedDate == curentDate) {
        return true;
      } else return false;
    },
    monthNames() {
      let m = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      return m;
    },
    EmployeeId() {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : "";
    },
    OrgId() {
      return this.loggedInUserObj.orgId;
    },
    isSupervisor() {
      return this.loggedInUserObj.IsSupervisor;
    },
    selectedMonthNumber()
    {
       let m = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      return m.indexOf(this.MonthSelected)+1
    },
    APPLICATIONBASEURL() {

      if(c.APPLICATIONBASEURL == 'https://demoess.onblick.com'){

        return 'https://demohr.onblick.com'

      }
      
      else if(c.APPLICATIONBASEURL == 'https://ess.onblick.com'){

        return 'https://hr.onblick.com'

      }

    },
  },
  created() {
    this.getTimeSheetPreference()
      bus.listen("openPopoverFromRedirection", () => {
        this.openPopoverFromRedirection()
      })
      bus.listen("OnTimesheetLengendClick", (obj) => {
       this.eventClick(obj)
      })
      bus.listen("OnArrowClick", (obj,clickEmpId) => {
       this.OnexpenseClick(obj,clickEmpId)
      })
      // bus.listen("onArrowdown",(obj,clickEmpId) => {
      //   this.OnExpenseDown(obj,clickEmpId)
      // })
      bus.listen("OnHrsArrowClick", (obj,monthNo) => {
       this.OnYrHrClick(obj,monthNo)
      })
       bus.listen("OnExpArrowClick", (obj,monthNo) => {
       this.OnYrExpClick(obj,monthNo)
      })

      this.getIsEditTimesheet()
      this.isCombinedReport =""

  },
  methods: {
    openDeleteTimesheet(id, selectedEvent, type){
      //this.DtimesheetId = id
      if(selectedEvent != null){
        if(type == "Timesheet"){
          this.DtimesheetId = selectedEvent.TimesheetId 
        }
        else{
          this.DtimesheetId = selectedEvent.ExpenseId
        }
        this.DeleteTimesheet = selectedEvent
        this.DeleteType = type
        this.openDeleteTimesheetPopup = true
      }
    },
    DeleteTimesheetM(reason, deletetype){
      if(this.DtimesheetId && this.DeleteTimesheet && this.DeleteTimesheet.EmployeeId && reason){
          this.$loading({ 'loadingText': 'Loading...' })   
          ajax.put(`TimeSheets/Delete/${this.DtimesheetId}?employeeId=${this.DeleteTimesheet.EmployeeId}&type=${deletetype}&reason=${reason}`, {}, (res) => {
            if (res.data.State == true) {
              let localEventObj = {
                Id: this.DeleteTimesheet.Id,
                IsPagefullLoad: true,
                EmployeeId: this.DeleteTimesheet.EmployeeId,
                Status: "deleted",
                type: deletetype
              }
              this.refetchEvents(localEventObj)
              this.$message({
                type: 'success',
                message: "Deleted Successfully"
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.Message
              })
            }
            this.$loading({}).close();
          })  
        this.openDeleteTimesheetPopup = false
      }
    },

    getTimeSheetPreference(){
      this.$loading({'loadingText': 'Loading...'}) 
        ajax.get(`TimeSheets/Settings?orgId=${this.loggedInUserObj.orgId}`, {} , (res) => {
              this.IsDCAAComplianceToggleOn = res.data.TimesheetSettings.DCCACompliance
              localStorage.setItem("IsDCAAComplianceToggleOn", this.IsDCAAComplianceToggleOn);
              this.submissionPreferenceType = res.data.TimesheetSettings.TimesheetSubmissionPrefference
            })
    },
     ViewActivityLog(){
      this.$router.push({path:`dcaa-reports?id=${this.LegendEmployeeId}`})
        //this.$router.push({name:"supervisior-activitylog"})
    },
    OnYrExpClick(info,monthNo){
      var monthNum = parseInt(monthNo);
      var selectedObj = this.MonthlyHoursExpense.find(v=>parseInt(v.Month) == monthNum);
      if(selectedObj != undefined)
      {
           this.yrApprovedExpense = selectedObj.ApprovedExpenseAmount;
           this.yrPendingExpense = selectedObj.PendingExpenseAmount;
           this.yrRejectedExpense = selectedObj.RejectedExpenseAmount;
      }
      setTimeout(() => {
          this.showPopover = true;
          this.showExpPopover = true;
           this.showPopover = false;
          setTimeout(() => {
            createPopper(info, this.$refs.expPopoverWrapper, {
              placement: "bottom"
            });
            setTimeout(() => {
                this.showPopover = true;
            }, 50);
          }, 0);
        }, 0);
    },
    OnYrHrClick(info,monthNo){
      var monthNum = parseInt(monthNo);
      var selectedObj = this.MonthlyHoursExpense.find(v=>parseInt(v.Month) == monthNum);
      if(selectedObj != undefined)
      {
           this.yrApprovedHrs = selectedObj.ApprovedHours;
           this.yrPendingHrs = selectedObj.PendingHours;
           this.yrRejectedHrs = selectedObj.RejectedHours;
      }


      setTimeout(() => {
          this.showPopover = true;
          this.showHrPopover = true;
           this.showPopover = false;
          setTimeout(() => {
            createPopper(info, this.$refs.hrPopoverWrapper, {
              placement: "bottom"
            });
            setTimeout(() => {
                this.showPopover = true;
            }, 50);
          }, 0);
        }, 0);
    },
    
    OnexpenseClick(info,clickEmpId){
       let clList = this.$store.getters.getTimesheetCustomMonthlyList;
        let popoverObj = clList.filter(v=>v.EmployeeId == clickEmpId)

           this.ApprovedHrs = popoverObj[0].AprovedHours;
          this.PendingHr = popoverObj[0].PendingHours;
          this.ApprovedExpense = popoverObj[0].ApprovedExpenses
          this.PendingExpense =  popoverObj[0].PendingExpenses
          this.Employeename=popoverObj[0].EmployeeName
          localStorage.setItem('EmployeeName', JSON.stringify(popoverObj[0].EmployeeName))
          //localStorage.setItem('EmployeeId', JSON.stringify(popoverObj[0].EmployeeId))
          this.LegendEmployeeId = popoverObj[0].EmployeeId;
          this.RejectedHrs = popoverObj[0].RejectedHours;
          this.RejectedExpense = popoverObj[0].RejectedExpenses
          this.isModalvisible = false
          this.missingTimesheetDate = moment("01/01/1970").format("MM/DD/YYYY")
          this.missingTimesheetDate1 = moment("01/01/1970").format("MM/DD/YYYY")
          this.getBannerContent(popoverObj)
          //this.closeExpensePopover()
//         var ApprovedDecimalTimeString = popoverObj[0].MonthlyApprovedWorkedHours;
//         var ApprovedDecimalTime = parseFloat(ApprovedDecimalTimeString);
//         ApprovedDecimalTime = ApprovedDecimalTime * 60 * 60;
//         var Approvedhours = Math.floor((ApprovedDecimalTime / (60 * 60)));
//         ApprovedDecimalTime = ApprovedDecimalTime - (Approvedhours * 60 * 60);
//         var Approvedminutes = Math.floor((ApprovedDecimalTime / 60));

//        // this.ApprovedHrs = Approvedhours +"h"+" "+Approvedminutes+"m"
//         if (Approvedminutes > 0 ){
//               this.ApprovedHrs = Approvedhours +"h"+" "+Approvedminutes+"m"
//         }
//         else {
//              this.ApprovedHrs = Approvedhours +"h"
//         }

//         var pendingDecimalTimeString = popoverObj[0].MonthlyPendingWorkedHours;
//         var pendingDecimalTime = parseFloat(pendingDecimalTimeString);
//         pendingDecimalTime = pendingDecimalTime * 60 * 60;
//         var pendinghours = Math.floor((pendingDecimalTime / (60 * 60)));
//         pendingDecimalTime = pendingDecimalTime - (pendinghours * 60 * 60);
//         var pendingminutes = Math.floor((pendingDecimalTime / 60));

//        // this.PendingHr = pendinghours +"h"+" "+pendingminutes+"m"
//        if (pendingminutes > 0 ){
//               this.PendingHr = pendinghours +"h"+" "+pendingminutes+"m"
//         }
//         else {
//              this.PendingHr = pendinghours +"h"
//         }
// 
//         this.ApprovedExpense = popoverObj[0].MonthlyApprovedExpenses
//         this.PendingExpense =  popoverObj[0].MonthlyPendingExpenses

        setTimeout(() => {
          this.showPopover = true;
          this.showExpensePopover = true;
           this.showPopover = false;
          setTimeout(() => {
            createPopper(info, this.$refs.expensePopoverWrapper, {
              placement: "bottom"
            });
            setTimeout(() => {
                this.showPopover = true;
            }, 50);
          }, 0);
        }, 0);
    },
    openPopoverFromRedirection()
    {
       let sourecId =  this.$route.query.Id ;
       if(sourecId != undefined && sourecId != null && sourecId != "")
       {
        var ele = jquery(`[data-event-id*=${sourecId}]`);

        if(ele != undefined && ele != null && ele != "" && ele.length > 0 )
        {

        var leftDiv = document.getElementById('CalenderInnerDiv');

        var dateNumber = parseInt(moment(this.$route.query.calenderDate).format('DD'));
        if(dateNumber > 15)
        {
            leftDiv.scrollLeft += 650;
        }
        let cList = this.$store.getters.getTimesheetCustomMonthlyList;
        this.eventObj = cList[0].CalendarList.filter(v=>v.Id == sourecId)

          setTimeout(() => {
            this.showTimeSheetsPopover = true;
            setTimeout(() => {
              createPopper(ele, this.$refs.timeSheetPopoverWrapper, {
                placement: "bottom"
              });
            }, 0);
          }, 0);
          //this.$router.replace({'query': null});
       }
       }
    },
    OnPreviousMonthClick() {
      let x = `${this.$parent.$parent._data.Year}-${this.selectedMonthNumber}-01`;
      let y = moment(x)
        .subtract(1, "months")
        .format("YYYY-MM-DD");
      let date = moment(y).format("YYYY-MM-DD");
      this.updateURL(date);
      this.MonthSelected = moment(date).format("MMMM");
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(date);
    },
    OnNextMonthClick() {
      let x = `${this.$parent.$parent._data.Year}-${this.selectedMonthNumber}-01`;
      let y = moment(x)
        .add(1, "months")
        .format("YYYY-MM-DD");
      let date = moment(y).format("YYYY-MM-DD");
      this.updateURL(date);
      this.MonthSelected = moment(date).format("MMMM");
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(date);
    },
    re_loadCalenderOnActions(obj) {
      //update scroll position
    //  var filterStatus = this.$store.getters.getTimeSheetFilterValue('TimeSheetStatus')
    //   if(document.getElementById("CalenderInnerDiv") != null)
    //   {
    //   var position = document.getElementById("CalenderInnerDiv").scrollTop;
    //   this.$store.commit("updateTimesheetScrollPosition", position);
    //   }

    //   this.$parent.$parent.OnTimesheetApprove(false); //to hide legend
    //   var eventId = obj.Id;
    //   var empId = obj.EmployeeId;
    //   let cList = this.$store.getters.getTimesheetCustomMonthlyList;
    //   let empIndex = cList.findIndex(c => c.EmployeeId == empId);
    //   let status = obj.Status;
    //   let type = obj.type;
    //   let from = obj.from;

    //   let approvedBy = {
    //     CurrentRole: "Supervisor",
    //     Designation: this.loggedInUserObj.designation,
    //     Email: this.loggedInUserObj.email,
    //     Id: this.loggedInUserObj.empId,
    //     Name: this.loggedInUserObj.name,
    //     ProfilePicLink: this.loggedInUserObj.profilepic
    //   };

    //   if (empIndex != -1) {
    //     let employee = cList[empIndex];
    //     let eventIndex = employee.CalendarList.findIndex(e => e.Id == eventId);
    //     if (eventIndex != -1) {
    //       let event = employee.CalendarList[eventIndex];
    //       if (status == "Rejected" || status == "Revoked") {
    //         // event = []
    //         cList[empIndex].CalendarList.splice(eventIndex, 1);
    //       }
    //       else if(status == "Approved" && type == "Timesheet" && filterStatus != undefined && filterStatus != null && filterStatus != "")
    //       {
    //           cList[empIndex].CalendarList.splice(eventIndex, 1);
    //           let newList = cList[empIndex].CalendarList.filter(x=>x.CalendarType == "TimeSheet" && x.Status == "Pending");
    //           if(newList.length <= 0)
    //           {
    //             cList.splice(empIndex, 1);
    //           }
    //       }
    //       else
    //       {
    //         if (type == "Timesheet") {
    //           if (from == "Popover") {
    //             event.ApprovedDate = moment().format("MM/DD/YYYY");
    //             event.ApprovedBy = approvedBy;
    //             event.Status = obj.Status;
    //             event.ApporvedExpenseAmount = event.SubmittedExpenseAmount
    //           } else if (status == "updateDates") {
    //             if (obj.isSubmitDate) {
    //               event.SubmittedDate = obj.date;
    //             } else {
    //               event.ApprovedDate = obj.date;
    //             }
    //           } else if (status == "Approved") {
    //             event.ApprovedDate = moment().format("MM/DD/YYYY");
    //             event.ApprovedBy = approvedBy;
    //             event.Status = obj.Status;
    //             event.HoursPerDay = obj.HoursPerDay;
    //             event.HoursWorked = obj.HoursWorked;
    //             event.AttachmentUrls = obj.TimesheetAttachments;
    //             event.ApporvedExpenseAmount = obj.ExapnseAmount;
    //             event.ExpenseAttachmentUrls = obj.ExpanseAttachments;
    //           }
    //         } else if (type == "Leave") {
    //           if (status == "Approved") {
    //             event.ApprovedDate = moment().format("MM/DD/YYYY");
    //             event.ApprovedBy = approvedBy;
    //             event.Status = obj.Status;
    //           }
    //         }
    //         cList[empIndex].CalendarList[eventIndex] = event;
    //       }
    //       //cList[empIndex].CalendarList[eventIndex] = event
    //     }
    //     this.$store.commit("updateTimesheetCustomMonthlyList", cList);
        window.bus.fire("refreshCalender");
    //  }
    },
    getIsEditTimesheet(){
      this.$loading({'loadingText': 'Loading...'}) 
            ajax.get(`TimeSheets/Settings?orgId=${this.loggedInUserObj.orgId}`, {} , (res) => {
              if(res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval != null && res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval != undefined){
              this.IsEditTimesheet = res.data.TimesheetSettings.AllowTimeSheetUpdateAfterApproval.PreferenceApplied
            }
              this.$loading({}).close()
            })
    },
    onEmployerEditTimesheetClose() {
      this.$parent.$parent.OnTimesheetApprove(false);
      this.EditTimesheetToApprove = false;
      this.showTimeSheetsPopover = false; //close popover
      this.openEvaluationReport = false;
    },
    onTodayButtonClick() {
      let date = moment().format("YYYY-MM-DD");
      this.MonthSelected = moment(date).format("MMMM");
      this.updateURL(date);
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(date);
    },
    onMonthSelected(item) {
      let monthNum = moment().month(item).format("M");
      let x = `${this.$parent.$parent._data.Year}-${monthNum}-01`;
      let date = moment(x).format("YYYY-MM-DD");
      this.updateURL(date);
      this.MonthSelected = moment(date).format("MMMM");
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(date);
       this.$refs.popover.doClose();
    },
    closeTimeSheetsPopover() {
      if (this.showTimeSheetsPopover == true)
        this.showTimeSheetsPopover = false;
        this.showPopover = false;
    },
    closeExpensePopover() {
      if (this.showExpensePopover == true)
        this.showExpensePopover = false;
        this.showPopover = false;
    },
    // closeExppopover(){
    //      if (this.showExpensePopover == false)
    //     this.showExpensePopover = true;
    //     this.showPopover = true;
    // },
    closeHrPopover(){
      if (this.showHrPopover == true)
        this.showHrPopover = false;
        this.showPopover = false;
    },
    closeExpPopover(){
      if (this.showExpPopover == true)
        this.showExpPopover = false;
        this.showPopover = false;
    },
    OpenEditEvaluation(event) {
      this.selectedEventInfo = event;
      this.openEvaluationReport = true;
      this.isEdit = true;
    },
    closeResubmitRequestPopUp(){
      this.reasonForReSubmit = ""
      this.showRequestPopUp = false
    },
    onApproveTimesheet(event,type) {
      this.$loading({ loadingText: "Loading..." });
      var Obj = {
        Id: event.Id,
        EmployeeId: event.EmployeeId,
        Type:type
      };
      ajax.put(`TimeSheets/Approve`, Obj, res => {
        if (res.data.State == true) {
          // this.onEmployerEditTimesheetClose();
          let localObj = {
            Id: event.Id,
            IsPagefullLoad: true,
            EmployeeId: event.EmployeeId,
            Status: "Approved",
            type: "Timesheet",
            from: "Popover"
          };
          this.refetchEvents(localObj);
          this.$message({
            type: "success",
            message:type== "TimesheetExpense" ? "Timesheet(s) and Expense(s) approved successfully" : type == "Timesheet" ? "Timesheet(s) approved successfully": "Expense(s) approved successfully",
            //message: "Timesheet(s) approved successfully"
          });
          this.$loading({}).close();
        } else if (res.data.State == false) {
          this.$loading({}).close();
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    },
    openEditTimesheetToApprove(event,type) {
      this.TimesheetId = event.Id;
      this.TimesheetEmployeeId = event.EmployeeId;
      this.$parent.$parent.OnTimesheetApprove(true); //to hide legend
      this.showTimeSheetsPopover = false; //close popover
      this.selectedEventInfo = event;
      this.EditTimesheetToApprove = true;
      this.TimesheetOrExpense = type;
    },
    openRequestForReSubmitPopup(event,type){
      this.TimesheetId = event.Id
      this.EmployeeId = event.EmployeeId
      this.showRequestPopUp = true
      this.requestForResubmitType = type
    },
    RequestToReSubmit(){
      this.$loading({'loadingText': 'Loading...'}) 
            ajax.put(`TimeSheets/RequestToReSubmit?id=${this.TimesheetId}&reSubmittedReason=${this.reasonForReSubmit}&TimesheetExpenseType=${this.requestForResubmitType}`, {} , (res) => {
            if(res.data.State == true){
              this.reasonForReSubmit = ""
              let localObj = {
              Id: this.TimesheetId.Id,
              IsPagefullLoad: true,
              EmployeeId: this.EmployeeId,
              Status: "Pending",
              type: "Timesheet",
              from: "Popover"
            };
              this.refetchEvents(localObj);
              this.showRequestPopUp = false
              this.$message({
                        type: 'success',
                        message: this.requestForResubmitType== 'Timesheet' ? 'Timesheet sent for resubmission successfully.':'Expense sent for resubmission successfully.'
                    })
            }
            else{
            this.$message({
                type: 'error',
                message: res.data.Message
                })
            }
            this.$loading({}).close()
        })
    },
    //Need to Update with Timesheet Report
    onOpenApprovalreport(v, event) {
      this.TimesheetId = event.Id;
      this.TimesheetEmployeeId = event.EmployeeId;
      this.showTimeSheetsPopover = false; //close popover
      this.selectedEventInfo = event;
      this.$loading({ loadingText: "Loading..." });
      this.iframeURL = "";
      ajax.get(
        `TimeSheets/Report/${event.TimesheetId}?employeeId=${event.EmployeeId}`,
        {},
        res => {
          if (res.data.State == true) {
            this.iframeURL = utils.getFilePreviewLink(res.data.ReportUrl);
            // this.CanEvaluate = v ;
            this.openEvaluationReport = true;
            // this.isEdit = false
          }
          this.$loading({}).close();
        }
      );
    },
    openEvaluation() {
      this.openEvaluationReport = true;
    },
    onTimeSheetApproved(obj) {
      let IsPagefullLoad = true;
      this.refetchEvents(obj);
      this.openEvaluationReport = false;
      this.openApprovalreport = false;
    },
    refetchEvents(obj) {
      // let calendarApi = this.$refs.fullCalendar.getApi();
      // calendarApi.refetchEvents();
      // this.showTimeSheetsPopover = false; //close popover
      if (this.defaultView == "customViewMonthly") {
        this.re_loadCalenderOnActions(obj);
        this.onEmployerEditTimesheetClose();
      // } else if (this.defaultView == "customViewYearly") {
      //   this.re_loadCalenderOnActions(obj);
      } else {
        let calendarApi = this.$refs.fullCalendar.getApi();
        calendarApi.refetchEvents();
        this.showTimeSheetsPopover = false; //close popover
      }
    },
    events: function(info, successCallback, failureCallback) {
      var startDate = moment(info.start).format("MM/DD/YYYY");
      if (this.defaultView == "customViewMonthly") {
        var pageNo = this.getUrlVars()["pageNo"];
        var pageSize = 15;
        var orgId = this.OrgId;

        var sDate = moment(
          decodeURIComponent(this.getUrlVars()["calenderDate"])
        ).format("MM/DD/YYYY");
        if (sDate != "Invalid date" && startDate != sDate) {
          this.$emit("changedDate", sDate, true);
        } else {
          this.$emit("changedDate", startDate, false);
        }
        var calenderDate = sDate && sDate != "Invalid date" ? sDate : null;
        if (
          calenderDate != null &&
          calenderDate != "" &&
          calenderDate != undefined
        ) {
          startDate = calenderDate;
        }
        var sText = this.getUrlVars()["searchText"];
        var searchText =
          sText && sText != "null" ? decodeURIComponent(sText) : "";
        var month = moment(startDate).format("MM");
        var year = moment(startDate).format("YYYY");
        var sampleDate = `${year}-${month}-01`;
        successCallback([
          {
            id: 1,
            title: "",
            start: sampleDate,
            end: sampleDate,
            EventObj: {
              month: month,
              year: year,
              orgId: orgId,
              searchText: searchText,
              IsPagefullLoad: this.IsPagefullLoad,
              PageNo:pageNo
            },
            type: "",
            status: ""
          }
        ]);
      } else if (this.defaultView == "customViewYearly") {
        var year = moment(startDate).format("YYYY");
        this.$emit("changedDate", startDate);
        this.$loading({ loadingText: "Loading..." });
        ajax.get(
          `/TimeSheets/Employee/Yearly/List/${this.EmployeeId}?year=${year}`,
          {},
          res => {
            this.yearlyCalList = res.data.CalendarList;
            let monthlyHoursAndExpense = res.data.monthlyHoursAndExpense;
            this.MonthlyHoursExpense = monthlyHoursAndExpense;
            successCallback(
              Array.prototype.slice
                .call(res.data.CalendarList)
                .map(function(eventEl) {
                  return {
                    id: eventEl.Id,
                    title: "",
                    start: eventEl.FromDateTime,
                    end: eventEl.ToDateTime,
                    EventObj: eventEl,
                    type: eventEl.CalendarType,
                    status: eventEl.Status,
                    ExpenseStatus:eventEl.ExpenseStatus,
                    monthlyHoursAndExpense : monthlyHoursAndExpense
                  };
                })
            );
            this.$loading({}).close();
          }
        );
      } else {
        this.EventIdList = [];
        this.TotalHoursWorkrd = "0h";
        var monthstartDate = moment(info.start)
          .add("days", 7)
          .format("MM/DD/YYYY");
        this.$emit("changedDate", monthstartDate);
        var month = moment(monthstartDate).format("MM");
        var year = moment(monthstartDate).format("YYYY");
        this.$loading({ loadingText: "Loading..." });
        ajax.get(
          `/TimeSheets/Employee/Monthly/List/${this.EmployeeId}?month=${month}&year=${year}`,
          {},
          res => {
            this.TotalHoursWorkrd = res.data.TotalWorkedHours;

            successCallback(Array.prototype.slice
                .call(res.data.CalendarList)
                .map(function(eventEl) {
                  return {
                    id: eventEl.Id,
                    title: "",
                    start: eventEl.FromDateTime,
                    end: eventEl.ToDateTime.replace('T00:00:00Z', 'T23:59:59Z'),
                    EventObj: eventEl,
                    type: eventEl.CalendarType,
                    status: eventEl.Status,
                    ExpenseStatus: eventEl.ExpenseStatus,
                  };
                }));
            this.$loading({}).close();
          }
        );
      }
    },
    renderEvent() {},
    convertToJSDate(eventDate){
      let date = new Date(eventDate)
      return date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1) + '-' + date.getUTCDate() 
    },
    gotoDate(year) {
      //update scroll position
      if(document.getElementById("CalenderInnerDiv") != null)
      {
      var position = document.getElementById("CalenderInnerDiv").scrollTop;
      this.$store.commit("updateTimesheetScrollPosition", position);
      }
      if (this.defaultView == "dayGridMonth") {
        let x = `${this.$parent.$parent._data.Year}-${this.selectedMonthNumber}-01`;
        year = moment(x).format("YYYY-MM-DD");
      }
      this.$store.commit('UpdateManualRemainderEmpIds', []);
      this.IsPagefullLoad = true;
      this.updateURL(year);
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(year);
    },
     updateURL(year) {
      if (history.pushState) {
        var searchText = this.getUrlVars()["searchText"];
        var pageNo = this.getUrlVars()["pageNo"];

        var baseUEL = window.location.protocol + "//" + window.location.host + window.location.pathname;
        var newurl = "";
        if (searchText != undefined && searchText != null && pageNo != undefined && pageNo != null) {
          newurl = baseUEL +"?searchText=" + searchText + "&calenderDate=" + year +  "&pageNo="+pageNo+"";
          this.$route.query.calenderDate = year;
          this.$route.query.searchText = searchText;
          this.$route.query.pageNo = pageNo;
        }
        else if (searchText != undefined && searchText != null) {
          newurl = baseUEL +"?searchText=" + searchText + "&calenderDate=" + year + "";
          this.$route.query.calenderDate = year;
          this.$route.query.searchText = searchText;
        }
        else if (pageNo != undefined && pageNo != null) {
          newurl = baseUEL +"?calenderDate=" + year +  "&pageNo="+pageNo+"";
          this.$route.query.calenderDate = year;
          this.$route.query.pageNo = pageNo;
        }
        else {
          newurl = baseUEL + "?calenderDate=" + year + "";
          this.$route.query.calenderDate = year;
        }
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    getUrlVars() {
      var vars = [],
        hash;
      var hashes = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    dayRender: function(info) {},
    eventPositioned: function(view) {},
    datesRender(info) {},
    eventSelected(event, jsEvent) {},
    eventClick(info) {
      this.eventObj = [];
      if (this.defaultView == "customViewMonthly") {
        //let parsed = JSON.parse(info[1].defs);
        for (var k = 0; k < info.length; k++) {
          if (info[k] != null) {
            this.eventObj.push(JSON.parse(info[k].defs));
          }
        }
        setTimeout(() => {
          this.showPopover = true;
          this.showTimeSheetsPopover = true;
           this.showPopover = false;
          setTimeout(() => {
            createPopper(info[0].el, this.$refs.timeSheetPopoverWrapper, {
              placement: "bottom"
            });
            setTimeout(() => {
                this.showPopover = true;
            }, 50);
          }, 0);
        }, 0);
      } else if (this.defaultView == "customViewYearly") {
        //let parsed = JSON.parse(info.defs);
        for (var k = 0; k < info.length; k++) {
          if (info[k] != null) {
            var event = JSON.parse(info[k].defs);
            this.eventObj.push(event.extendedProps.EventObj);
          }
        }
        //this.eventObj = parsed.extendedProps.EventObj;
        setTimeout(() => {
          this.showPopover = true;
          this.showTimeSheetsPopover = true;
          this.showPopover = false;
          setTimeout(() => {
            createPopper(info[0].el, this.$refs.timeSheetPopoverWrapper, {
              placement: "bottom"
            });
            setTimeout(() => {
                this.showPopover = true;
            }, 50);
          }, 0);
        }, 0);
      } else {
        this.eventObj[0] = info.event._def.extendedProps.EventObj;
        setTimeout(() => {
          this.showPopover = true;
          this.showTimeSheetsPopover = true;
          this.showPopover = false;
          setTimeout(() => {
            createPopper(info.el, this.$refs.timeSheetPopoverWrapper, {
              placement: "bottom"
            });
            setTimeout(() => {
                this.showPopover = true;
            }, 50);
          }, 0);
        }, 0);
      }
    },
     EnumerateDaysBetweenDates(startDate, endDate) {
      var now = startDate, dates = [];
      while (now.isSameOrBefore(endDate)) {
        dates.push(now.format('MM/DD/YYYY'));
        now.add(1, 'days');
      }
      return dates;
    },
    eventRender(info) { 
      this.EventIdList.push(info.event.extendedProps.EventObj.Id);
      //event,el,view
      //this code need to be refactor (by replace like logic)
      if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Pending" && info.event.extendedProps.EventObj.ExpenseStatus == "Rejected")
      ){
        jquery(info.el).addClass("custom-event-background2_1");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.InvoiceStatus == "Invoice Generated" )
      ){
        jquery(info.el).addClass("custom-event-background_81");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.ExpenseStatus == "Pending")
      ){
        jquery(info.el).addClass("custom-event-background2");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.ExpenseStatus == "Saved")
      ){
        jquery(info.el).addClass("custom-event-background2_2");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.ExpenseStatus == "Rejected")
      ){
        jquery(info.el).addClass("custom-event-background2_1");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (

        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Approved" || info.event.extendedProps.EventObj.ExpenseStatus == "Approved")
      ){
        if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') && info.event.extendedProps.EventObj.ExpenseStatus == "None"){
          jquery(info.el).addClass("custom-event-background7")
        }
        else if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') && (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
          jquery(info.el).addClass("custom-event-background7")
        }
        else if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit')){
          if((info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployerRejectEditRequest') || (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeCancelEditRequest') || (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'Approved')){
              jquery(info.el).addClass("custom-event-background1");
          } 
        }
        else if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
          jquery(info.el).addClass("custom-event-background7")
        }
        else jquery(info.el).addClass("custom-event-background1");
        this.bindingHoursToDateEventLegend(info)   
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Pending" && info.event.extendedProps.EventObj.ExpenseStatus == "Saved")
      ){
        jquery(info.el).addClass("custom-event-background2_2");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Pending" || info.event.extendedProps.EventObj.ExpenseStatus == "Pending")
      ){
        jquery(info.el).addClass("custom-event-background2");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Rejected" && info.event.extendedProps.EventObj.ExpenseStatus == "Saved")
      ){
        jquery(info.el).addClass("custom-event-background2_2");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Rejected" || info.event.extendedProps.EventObj.ExpenseStatus == "Rejected")
      ){
        jquery(info.el).addClass("custom-event-background6");
        this.bindingHoursToDateEventLegend(info)
      }
      else if (
        info.event.extendedProps.EventObj.CalendarType == "Leave" &&
        info.event.extendedProps.EventObj.Status == "Pending"
      )
        jquery(info.el).addClass("custom-event-background4");
      else if (
        info.event.extendedProps.EventObj.CalendarType == "Leave" &&
        info.event.extendedProps.EventObj.Status == "Approved"
      )
        jquery(info.el).addClass("custom-event-background3");
      else if (info.event.extendedProps.EventObj.CalendarType == "Holiday")
        jquery(info.el).addClass("custom-event-background5");

      else if (
        info.event.extendedProps.EventObj.CalendarType == "TimeSheet" &&
        (info.event.extendedProps.EventObj.Status == "Saved" || info.event.extendedProps.EventObj.ExpenseStatus == "Saved")
      )
       jquery(info.el).addClass("custom-event-background-timesheet-save");
        
    },
    bindingHoursToDateEventLegend(info){
       var datefrom = moment(info.event.extendedProps.EventObj.FromDate).format('MM/DD/YYYY');
       var dateTo =  moment(info.event.extendedProps.EventObj.ToDate).format('MM/DD/YYYY');
       let getactiveDate = moment(this.$refs.fullCalendar.getApi().view.activeStart).format("MM/DD/YYYY")
       if(moment(datefrom).month() < this.selectedMonthNumber-1)
        {
          datefrom = moment(`${this.selectedMonthNumber}/01/${this.$parent.$parent._data.Year}`).format('MM/DD/YYYY');
        }
        else if(moment(datefrom) < moment(getactiveDate)){
          datefrom = moment(this.$refs.fullCalendar.getApi().view.activeStart).format("MM/DD/YYYY")
        }
        if(moment(dateTo).month() > this.selectedMonthNumber-1)
          {
            dateTo = moment(`${this.selectedMonthNumber+1}/01/${this.$parent.$parent._data.Year}`).add(-1, 'days').format('MM/DD/YYYY');
        }
        const week_start_date = moment(datefrom).startOf('week').format('MM/DD/YYYY');
        const week_end_date = moment(dateTo).endOf('week').format('MM/DD/YYYY');
        var dateList = (this.EnumerateDaysBetweenDates(moment(week_start_date), moment(datefrom).add(-1, 'days'))).concat(this.EnumerateDaysBetweenDates(moment(datefrom), moment(dateTo))).concat(this.EnumerateDaysBetweenDates(moment(dateTo).add(1, 'days'), moment(week_end_date)));
     
        var soretddateList = dateList.sort(function(a,b){
           return new Date(a.Date) - new Date(b.Date);
         })
       var weekDaysList = [];
      /// converting as double array list(calender view)
          let i = 0;
          let j = 0;
          for (i = 0; i < soretddateList.length; i++) {
            var x = [];
              for (j = 0; j < 7; j++) {
                x.push(soretddateList[i]);
                i++;
              }
              i--;
            weekDaysList.push(x);
          }
          
         var currentEvent = this.EventIdList.filter(x=>x == info.event.extendedProps.EventObj.Id);
         var totalhoursPerDay = info.event.extendedProps.EventObj.HoursPerDay;
         var RejectedHoursPerDay = totalhoursPerDay.filter(function (x) {
             return weekDaysList != null && weekDaysList[currentEvent.length - 1] != null && weekDaysList[currentEvent.length - 1] != undefined && weekDaysList[currentEvent.length - 1].includes(x.Date);
          });
         var divHtmlStr = ''
          RejectedHoursPerDay.forEach((hourObj,hIndex)=>{
              if(RejectedHoursPerDay.length == 1)
              {
                var dates = info.event.extendedProps.EventObj.InvoiceDates;
                let tsDate = moment(hourObj.Date).format('YYYY-MM-DD');
                if(info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.InvoiceStatus == "Invoice Generated" && dates.includes(tsDate))
                  divHtmlStr += '<div style="width:50%;text-align:center;"><div style="line-height:1.75;color:#A31D95;font-weight:800">'+ hourObj.Hours +'</div></div>'
                else if(info.event.extendedProps.EventObj.Status == "Pending" && info.event.extendedProps.EventObj.ExpenseStatus == "Rejected"){
                  divHtmlStr += '<div style="width: 100%;text-align:center;"><div style="line-height:1.75;color:#F8D21C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }
                else if(info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.ExpenseStatus == "Rejected"){
                  if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
                    divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#aa99d6;font-weight:800">'+ hourObj.Hours +'</div></div>'
                  }
                  else divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#13DA7C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }
                else if(info.event.extendedProps.EventObj.Status == "Rejected" || info.event.extendedProps.EventObj.ExpenseStatus == "Rejected"){
                  divHtmlStr += '<div style="width: 100%;text-align:center;"><div style="line-height:1.75;color:#ef4457;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }else if(info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.ExpenseStatus == "Pending"){
                  divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#13DA7C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }else if(info.event.extendedProps.EventObj.Status == "Pending" || info.event.extendedProps.EventObj.ExpenseStatus == "Pending"){
                  divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#F8D21C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }else if(info.event.extendedProps.EventObj.Status == "Approved" ||info.event.extendedProps.EventObj.ExpenseStatus == "Approved"){
                  if((info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
                    if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployerRejectEditRequest') || (info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeCancelEditRequest') || (info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'Approved')){
                      divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#13DA7C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                    } 
                    else if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit')){
                      divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#aa99d6;font-weight:800">'+ hourObj.Hours +'</div></div>'
                    }
                  }
                  else if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
                    divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#aa99d6;font-weight:800">'+ hourObj.Hours +'</div></div>'
                  }
                  else divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#13DA7C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }
              }
              else
              {
                var dates = info.event.extendedProps.EventObj.InvoiceDates;
                let tsDate = moment(hourObj.Date).format('YYYY-MM-DD');
                if(info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.InvoiceStatus == "Invoice Generated" && dates.includes(tsDate))
                  divHtmlStr += '<div style="width:50%;text-align:center;"><div style="line-height:2;color:#A31D95;font-weight:800">'+ hourObj.Hours +'</div></div>'
                else if(info.event.extendedProps.EventObj.Status == "Pending" && info.event.extendedProps.EventObj.ExpenseStatus == "Rejected"){
                  divHtmlStr += '<div style="width: 100%;text-align:center;"><div style="line-height:1.75;color:#F8D21C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }
                else if(info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.ExpenseStatus == "Rejected"){
                  if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
                    divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#aa99d6;font-weight:800">'+ hourObj.Hours +'</div></div>'
                  }
                  else divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#13DA7C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }
                else if(info.event.extendedProps.EventObj.Status == "Rejected" || info.event.extendedProps.EventObj.ExpenseStatus == "Rejected"){
                 divHtmlStr += '<div style="width: 50%;text-align:center;"><div style="line-height:1.75;color:#ef4457;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }
                else if(info.event.extendedProps.EventObj.Status == "Approved" && info.event.extendedProps.EventObj.ExpenseStatus == "Pending"){
                  divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#13DA7C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }else if(info.event.extendedProps.EventObj.Status == "Pending" || info.event.extendedProps.EventObj.ExpenseStatus == "Pending"){
                  divHtmlStr += '<div style="width:50%;text-align:center;"><div style="line-height:1.75;color:#F8D21C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }else if(info.event.extendedProps.EventObj.Status == "Approved" ||info.event.extendedProps.EventObj.ExpenseStatus == "Approved"){
                  if((info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
                    if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployerRejectEditRequest') || (info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeCancelEditRequest') || (info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'Approved')){
                      divHtmlStr += '<div style="width:50%;text-align:center;"><div style="line-height:1.75;color:#13DA7C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                    } 
                    else if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit')){
                      divHtmlStr += '<div style="width:100%;text-align:center;"><div style="line-height:1.75;color:#aa99d6;font-weight:800">'+ hourObj.Hours +'</div></div>'
                    }
                  }
                  else if((info.event.extendedProps.EventObj.TimesheetlatestLog != null && info.event.extendedProps.EventObj.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (info.event.extendedProps.EventObj.ExpenselatestLog != null && info.event.extendedProps.EventObj.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')){
                    divHtmlStr += '<div style="width:50%;text-align:center;"><div style="line-height:1.75;color:#aa99d6;font-weight:800">'+ hourObj.Hours +'</div></div>'
                  }
                  else divHtmlStr += '<div style="width:50%;text-align:center;"><div style="line-height:1.75;color:#13DA7C;font-weight:800">'+ hourObj.Hours +'</div></div>'
                }
             }
           })
           info.el.children[0].innerHTML = ''
           info.el.children[0].innerHTML = divHtmlStr 
           info.el.children[0].style.width = '100%'
           info.el.children[0].style.marginTop = '10px'
           info.el.children[0].style.visibility = 'visible'
           info.el.children[0].style.display = 'inline-flex'
           info.el.children[0].style.color = '#000'
    },
    closeRemindApproverPopUp(){
      this.openRemindPopUp = false
      this.copyShow = false
    },
    openRemindApproverPopUp(event){
      this.TimesheetId = event.Id
      this.EmployeeId = event.EmployeeId
      this.openRemindPopUp = true
      this.ProjectTitle = event.ProjectTitle
      this.FromDate=event.FromDate
      this.ToDate=event.ToDate
      this.ApproverName = event.ThirdPartyApprover.Name
      this.OTPForVerify = event.ThirdPartyApprover.OTP
      this.TimesheetExpenseType = type
      this.getApproverDetails()
    },
    getApproverDetails(){
      this.$loading({ 'loadingText': 'Loading...' })
      if(this.TimesheetId !='') {
        ajax.get(`TimeSheets/ThirdPartyVerify/ApproverDetails?timesheetId=${this.TimesheetId}`, {}, (res) => {
          if (res.data.State == true) {
            this.TimesheetEmployeeName = res.data.TimesheetThirdParty.EmployeeName
            if(res.data.TimesheetThirdParty.ThirdPartyApprover.OTP != null && res.data.TimesheetThirdParty.ThirdPartyApprover.OTP != undefined){
              this.OTPForVerify = res.data.TimesheetThirdParty.ThirdPartyApprover.OTP
            }
          } 
          else {
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
        })
      }
      this.$loading({}).close()
    },
    copyEmail() {
      this.copyShow = true;
      this.selectText(this.$refs.copyData);
    },
    selectText(element){
      var range;
      if (window.getSelection) {		
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeRange(range);
      }
    },
    OnRemind() {
          this.$loading({ 'loadingText': 'Loading...' })
          ajax.put(`TimeSheets/ThirdPartyVerify/ResendAccescode?timeSheetId=${this.TimesheetId}&type=${this.TimesheetExpenseType}`, {}, (res) => {
              if (res.data.State == true) {
                this.$message({
                  type: 'success',
                  message: "Reminder Mail Sent Successfully!"
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.Message
                })
              }
          })
          setTimeout(() => {
            this.$loading({}).close()
          }, 3000)
          this.openRemindPopUp = false
          this.copyShow = false
        },
    closeEditRequestPopUp(){
      this.reasonForEdit = ""
      this.showRequestForEditPopUp = false
    },
    openRequestForEditPopup(event,type){
      this.TimesheetId = event.Id
      this.EmployeeId = event.EmployeeId
      this.showRequestForEditPopUp = true
      this.requestToEditType =type
    },
    RequestToEdit(){
      this.$loading({'loadingText': 'Loading...'}) 
            ajax.put(`TimeSheets/RequestToEdit?id=${this.TimesheetId}&reSubmittedReason=${this.reasonForEdit}&type=${this.requestToEditType}`, {} , (res) => {
            if(res.data.State == true){
              this.reasonForEdit = ""
              let localObj = {
              Id: this.TimesheetId.Id,
              IsPagefullLoad: true,
              EmployeeId: this.EmployeeId,
              Status: "Pending",
              type: "Timesheet",
              from: "Popover"
            };
              this.refetchEvents(localObj);
              this.showRequestForEditPopUp = false
              this.$message({
                type: 'success',
                message:this.requestToEditType== 'Timesheet'? 'Timesheet Requested for edit successfully.':'Expense Requested for edit successfully.'
              })
            }
            else{
            this.$message({
                type: 'error',
                message: res.data.Message
                })
            }
            this.$loading({}).close()
        })
    },
    openRequestApproveOrRejectPopUp(event,type,TimesheetExpenseType){
      this.TimesheetId = event.Id
      this.EmployeeId = event.EmployeeId
      this.approveOrRejectRequestType = TimesheetExpenseType
      if(TimesheetExpenseType == 'Timesheet'){
        if(event.TimesheetlatestLog.AuthorizedBy != undefined && event.TimesheetlatestLog.AuthorizedBy != null && event.TimesheetlatestLog.AuthorizedBy.Name != null && event.TimesheetlatestLog.AuthorizedBy.Name != ''){
          this.RequestedEmployeeName = event.TimesheetlatestLog.AuthorizedBy.Name
        }
      }
      else{
        if(event.ExpenselatestLog.AuthorizedBy != undefined && event.ExpenselatestLog.AuthorizedBy != null && event.ExpenselatestLog.AuthorizedBy.Name != null && event.ExpenselatestLog.AuthorizedBy.Name != ''){
          this.RequestedEmployeeName = event.ExpenselatestLog.AuthorizedBy.Name
        }
      }
      if(type == 'approve'){
        this.approveRequest = true
      }
      else if(type == 'reject'){
        this.rejectRequest = true
      }
      this.showApproveOrRejectPopUp = true
    },
    RequestApproveOrReject(val){
      let endPoint;
      if(val == 'approve'){
        endPoint = `TimeSheets/ApproveEditRequest?id=${this.TimesheetId}&isApprove=true&reSubmittedReason=${this.reasonForApproveOrReject}&TimesheetExpenseType=${this.approveOrRejectRequestType}`
      }
      else{
        if(this.approveOrRejectRequestType == 'Timesheet'){
          endPoint = `TimeSheets/RejectEditRequest?id=${this.TimesheetId}&reSubmittedReason=${this.reasonForApproveOrReject}`
        }
        else{
          endPoint = `TimeSheets/RejectExpenseEditRequest?id=${this.TimesheetId}&reSubmittedReason=${this.reasonForApproveOrReject}`
        }
      }
      this.$loading({'loadingText': 'Loading...'}) 
            ajax.put(endPoint, {} , (res) => {
            if(res.data.State == true){
              this.reasonForApproveOrReject = ""
              let localObj = {
              Id: this.TimesheetId.Id,
              IsPagefullLoad: true,
              EmployeeId: this.EmployeeId,
              Status: "Pending",
              type: "Timesheet",
              from: "Popover"
            };
              this.refetchEvents(localObj);
              this.showApproveOrRejectPopUp = false
              if(val == 'approve'){
                this.$message({
                  type: 'success',
                  message: 'Request for edit approved successfully.'
                })
              }
              else{
                this.$message({
                  type: 'success',
                  message: 'Request for edit rejected successfully.'
                })
              }
            }
            else{
            this.$message({
                type: 'error',
                message: res.data.Message
                })
            }
            this.$loading({}).close()
        })
    },
    closeRequestApproveOrRejectPopUp(){
      this.reasonForApproveOrReject = ""
      this.showApproveOrRejectPopUp = false
      this.approveRequest = false
      this.rejectRequest = false
    },
    
     getBannerContent(cList){
        var date = moment("01/01/1970").format("MM/DD/YYYY")
        var date1=moment("01/01/1970").format("MM/DD/YYYY")
            if(this.submissionPreferenceType == 'MustBeEnteredOnSameDay'){
              date = moment().format('MM/DD/YYYY')
            }
            else if(this.submissionPreferenceType == 'CanBeEnteredOnTheNextDay'){
              var startdate = moment();
              startdate = startdate.subtract(1, "days");
              date = startdate.format('MM/DD/YYYY')
            }
            else if(this.submissionPreferenceType == 'CanBeEnteredInWeeksTime'){
              // var startdate=moment();
              // startdate =startdate.getDate() ;
              // date=startdate.format("MM/DD/YYYY")
              let startDate = moment().startOf('isoweek');
              let endDate = moment().endOf('week');
              date=startDate.format("MM/DD/YYYY")
              date1=endDate.format("MM/DD/YYYY")
              date = moment(startDate).twix(moment(endDate),true)
                  }
            var eventObj = []
            var count = 0
            for (let i = 0; i < (cList[0].CalendarList).length; i++) {
		          let c = cList[0].CalendarList[i]; 
              const range = moment(c.FromDate, 'MM/DD/YYYY').twix(moment(c.ToDate, 'MM/DD/YYYY'), true);
              if (range.contains(moment(date).format('YYYY/MM/DD'))) {
                var _totalHoursPerDay =
                c.HoursPerDay && c.HoursPerDay.length > 0
                ? c.HoursPerDay.filter((x) => {
                  return moment(x.Date).format('YYYY/MM/DD') == moment(date).format('YYYY/MM/DD');
						    })
					      : [];
                var x = {
                  Status: c.Status,
                  ExpenseStatus:c.ExpenseStatus,
                  CalendarType: c.CalendarType,
                  eventId: c.Id,
                  totalHoursPerDate:
                  _totalHoursPerDay[0] != null && _totalHoursPerDay.length > 0 ? _totalHoursPerDay[0].Hours : 0,
                };
                if(x.totalHoursPerDate!= 0 && (x.Status == 'Pending' || x.Status == 'Approved' ||x.Status== 'Saved' || x.ExpenseStatus == 'Approved' || x.ExpenseStatus=='Pending')){
                  count++
                }
			          eventObj.push(x);
	        	  }
	          }
            if(count == 0){
              this.isModalvisible = true
              this.missingTimesheetDate = date 
              this.missingTimesheetDate1 = date1
            }
        
    },
    viewReport(id, clickedType) {
      this.selectedEvent = this.eventObj.filter(v => v.Id == id)[0]
      var rType = ''
      if (clickedType == "Expense") {
        rType = 'ExpenseReport'
      } else {
        rType = 'TimesheetReport'
      }
      if(this.isCombinedReport === true){
        rType = 'TimesheetCombinedReport'
      }
      // this.$parent.onOpenApprovalreport(false,this.selectedEvent)
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.get(`TimeSheets/TimesheetReport/${id}?employeeId=${this.selectedEvent.EmployeeId}&Rtype=${rType}`, {}, (res) => {
        if (res.data.State == true) {
          window.open(res.data.ReportUrl, "_blank");
          this.$loading({}).close();
        } else {
          this.$loading({}).close();
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        } 
      })
    },
    ViewReportForSelectedType(){

      this.viewReport(this.selectedtimesheet.id,this.selectedtimesheet.clickedType)
    },
    cancelSelectReportTypePopUp(){
      this.openPopUpSelectReportType = false,
      this.IsReportTypeSelectedCombined = false
      this.isCombinedReport = ""
    }

}
};
</script>
<style lang='scss'>
@import "@fullcalendar/core/main.css";
@import "@fullcalendar/daygrid/main.css";
@import "@fullcalendar/timegrid/main.css";

@import "./CustomViews/main.scss";

.cross-img {
  width: 15px;
  border-radius: 50%;
  margin-left: 2px;
  margin-right: 2px;
  display: inline-block !important;
}
.cross-img-span {
  border-radius: 5px;
  padding: 2px 1px 2px 2px;
  cursor: pointer !important;
}
.popover-custom-width-leave-Pending {
  border: none;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-width: 350px;
}
.popover-custom-width-Approved {
  border: none;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-width: 440px;
}
.popover-custom-width-timesheet-Approved {
  border: none;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-width: 440px;
}
.popover-custom-width-Pending {
  border: none;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-width: 440px;
}
.popover-custom-width-holiday {
  border: none;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  width: 180px;
}
.custom-event-background1 {
  border: 1px solid #e7fbf2 !important;
  background: #e7fbf2 !important;
  //margin-top: -15px;
  border-bottom: 6px solid #13da7c !important;
}
.custom-event-background2 {
  border: 1px solid #fefae8 !important;
  background: #fefae8 !important;
  // margin-top: -15px;
  border-bottom: 6px solid #f8d21c !important;
}
.custom-event-background2_1
{
  // border: 1px solid #fefae8 !important;
  // background: #fefae8 !important;
  // // margin-top: -15px;
  // border-bottom: 6px solid #F96301 !important;

  border: 1px solid #fdeae5 !important;
  background: #fdeae5 !important;
  border-bottom: 6px solid #ef4457 !important;
}
.custom-event-background2_2
{
  border: 1px solid #fefae8 !important;
  background: #fefae8 !important;
  // margin-top: -15px;
  border-bottom: 6px solid #F96301 !important;
}
// .custom-event-background6 {
//   border: 1px solid #fdeae5 !important;
//   background: #fdeae5 !important;
//   border-bottom: 6px solid #ef4457 !important;
// }

.custom-event-background_81{
  background: #f8cef4!important;;
  border: 1px solid #a31d95!important;
  //border-bottom-width: 2px;
  border-bottom: 6px solid #a31d95 !important;
}

.custom-event-background3 {
  border: 1px solid #e9e9fc !important;
  background: #e9e9fc !important;
  // margin-top: -15px;
  border-bottom: 6px solid #2027e8 !important;
}
.custom-event-background4 {
  border: 1px solid #ebebeb !important;
  background: #ebebeb !important;
  // margin-top: -15px;
  border-bottom: 6px solid #35373a !important;
}
.custom-event-background5 {
  border: 1px solid #eeece9 !important;
  background: #eeece9 !important;
  border-bottom: 6px solid #b28b61 !important;
}
.custom-event-background6 {
  border: 1px solid #fdeae5 !important;
  background: #fdeae5 !important;
  border-bottom: 6px solid #ef4457 !important;
}
.custom-event-background-timesheet-save {
  border: 1px solid #FEDCC5 !important;
  background: #FEDCC5 !important;
  border-bottom: 6px solid #F96301 !important;
}
.custom-event-background7 {
  border: 1px solid #eee7ff !important;
  background: #eee7ff !important;
  //margin-top: -15px;
  border-bottom: 6px solid #aa99d6 !important;
}
.fc-content {
  margin-top: 15px;
}
.fc-content {
  visibility: hidden;
}
.fc-today {
  background: none !important;
}
.fc-today .fc-day-number {
  padding-top: 3px;
  text-align: center;
  height: 21px;
  background: #509bec !important;
  border-radius: 74px;
  width: 23px;
  /* margin-top: 4px; */
  color: #fff;
}

.fc-center {
  position: absolute;
  right: 526px;
  width: 215px;
}
.fc-prev-button {
  margin-top: -2px;
  /* margin-left: 1px; */
  float: left;
  display: inline-block;
}
.fc-center h2 {
  text-transform: uppercase;
  text-align: center;
  display: inline-block;
  width: 140px;
  font-size: 19px;
  padding-top: 2px;
  font-weight: 600;
  color: #1e1e1f;
}
.fc-next-button {
  margin-top: -2px;
  float: right;
}
.timesheet-calendar {
  margin: 0 auto;
}
.fc button {
  font-weight: 900 !important;
}
.fc-header-toolbar {
  padding: 10px 10px;
}
.fc-today-button {
  text-transform: capitalize !important;
  font-weight: 900 !important;
  border: none !important;
  background: #edf4fc !important;
  color: #509bec !important;
  margin-left: 10px !important;
}
.fc-prev-button,
.fc-next-button {
  background-color: #fff !important;
  border: none !important;
  color: black !important;
}
.fc-day-header {
  text-transform: uppercase !important;
  font-weight: 800 !important;
  font-size: 12px !important;
  color: #77797d !important;
}
.fc-widget-header,
.fc-day-top {
  background: #efefef;
}
.fc-widget-content {
  background: #fff;
}

.fc-day-number {
  font-weight: 600;
  font-size: 14px;
}
.fc-head {
  border-color: red !important;
}
.fc td,
.fc th {
  border-color: #dfdfdf !important;
}
.fc-myCustomButton-button {
  border: none;
  float: left;
  color: #000;
}

.timesheet-popover-wrapper {
  // border: 1px solid rgba(0,0,0,.2);
  padding: 10px 1px 2px 1px;
  z-index: 1060;
  max-width: 276px;
  position: absolute;
  background: #fff;
  top: 0;
  font-size: 14px;
  border-radius: 6px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.fc-content-skeleton {
  tr {
    background-color: #fff !important;
  }
}
</style>
<style lang="scss" scoped>
.Expense_popOver{
  background:white;
  box-shadow: 1px 1px 1px 1px #8888;
  margin-top: 5px;width: 34%;
  padding:14px;
}
.Expense_popOver1{
  background:white;
  box-shadow: 1px 1px 1px 1px #8888;
  margin-top: 5px;width: 22%;
  padding:14px;
}
.hr_popOver{
  background:white;
  box-shadow: 1px 1px 1px 1px #8888;
  margin-top: 5px;width: 22%;
  padding:14px;
}
// .exp_popOver{
//   background:white;
//   box-shadow: 1px 1px 1px 1px #8888;
//   margin-top: 5px;width: 21%;
// }
// .exp_popOver::after {
//   content: "";
//   position: absolute;
//   bottom: 100%;
//   left: 50%;
//   margin-left: -5px;
//   border-width: 5px;
//   border-style: solid;
//   border-color: transparent transparent #e9ebeffc transparent;
// }
.Expense_popOver .Expense_popOver1::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #e9ebeffc transparent;
}
.hr_popOver::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #e9ebeffc transparent;
}
.data_field{
  padding-top: 5px;
  font-size: 12px;
  font-weight: 600;
}
.circle2
{
  border-radius: 50%;
  width: 8px;
  height: 8px;
  display: inline-block;
  color:#13DA7C;
  background-color:#13DA7C;
  margin-right: 5px;
}
.circle1
{
  border-radius: 50%;
  width: 8px;
  height: 8px;
  display: inline-block;
  color:#f8d21c;
  background-color:#f8d21c;
  margin-right: 5px;
}
.popper {
  margin-top: 0 !important;
  margin-left: 0 !important;
  padding: 0px !important;
  height: 240px !important;
  overflow: auto !important;
  .snooze-options {
    color: #000000;
    display: block;
    font-size: 14px;
    padding: 7px;
  }
  .snooze-options:hover {
    color: #fff !important;
    background-color: #337ab7 !important;
  }
}
.todayButton {
  text-transform: capitalize !important;
  font-weight: 900 !important;
  border: none !important;
  background: #edf4fc !important;
  color: #509bec !important;
  margin-left: 5px !important;
  width: 65px;
  height: 28px;
  border-radius: 4px;
}
.todayButton:hover {
  color: black !important;
}
.totalHoursLable {
  background-color: #d1dade;
  color: #5e5e5e;
  font-family: "Open Sans";
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  text-shadow: none;
  font-size: 13px;
  float: right;
  background: none;
}
</style>
<style lang="scss" scoped>
@import '../../../../../static/Css/Content/SCSS/post-login-scss/scss/cdnVariables';
.cross-img-span:hover {
  background-color: #f6f7f8;
}
.arrow_icon {
  padding: 4px 6px 4px 7px;
  border-radius: 2px;
  margin-left: 5px;
}
.arrow_icon:hover {
  background-color: #edf4fc;
  cursor: pointer;
}
#prev:hover {
  content: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_previous-hover.svg");
}
#next:hover {
  content: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_next-hover.svg");
}
.circle3
{
  border-radius: 50%;
  width: 8px;
  height: 8px;
  display: inline-block;
  color:#EF4457;;
  background-color:#EF4457;;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/Calender/TimeSheetsCalender.vue